import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-field.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSFieldLabel = props => {
  const {
    id,
    label,
    className,
    children
  } = props;
  const cssClasses = getClassNameList('uitk-field-label', className);
  return jsx("label", {
    htmlFor: id,
    className: cssClasses,
    children: jsxs(Fragment, {
      children: [label, children]
    })
  });
};
EGDSFieldLabel.displayName = 'EGDSFieldLabel';
export { EGDSFieldLabel };